<template>
<v-dialog
    v-model="dialog"
    max-width="1200"
>
    <v-card>
        <v-card-title>Automatic Setup Actions</v-card-title>

        <v-card-text>

            <v-checkbox
                v-for="(item, index) in results"
                :key="index"
                v-model="selected"
                :value="item.value"
                :label="item.text"
                style="margin-bottom: -15px"
            />

        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Create Organization
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            selected: [],
            results: [],
        }
    },

    methods: {

        showDialog(organization_account)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/organizations/organization-account/on-create-auto-actions',
            
                'params' : organization_account,
            
                'on_success': (data) => {
                        this.dialog = true;

                        this.results = data.results;
                        this.selected = [];

                        for ( let i = 0; i < this.results.length; i++ )
                        {
                            if ( this.results[i].checked == true )
                            {
                                this.selected.push(this.results[i].value);
                            }
                        }
                    },
            
                'on_error': 'Unable to complete API call',
            });
            
        },

        onOk()
        {
            this.dialog = false;
            this.$emit('create-org', this.selected);
        },

        onCancel()
        {
            this.dialog = false;
        },

    },
}
</script>

<style lang="scss" scoped>
</style>